<template lang="pug">
    div
        q_searchable_static_ddl(
        question="Community/Volunteer/Work Activities/Jobs for Maine’s Graduates (JMG)"
        slug="q_community_activity"
        :multi_field_num="multi_field_num"
        )
        big(v-show="show_grades_title()") Grades Participated in
        q_checkbox(
        question="9"
        slug="q_community_9"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="10"
        slug="q_community_10"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="11"
        slug="q_community_11"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="12"
        slug="q_community_12"
        :multi_field_num="multi_field_num"
        )
        q_checkbox(
        question="Post Graduation"
        slug="q_community_pg"
        :multi_field_num="multi_field_num"
        )
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_checkbox from "../../baseQuestion/checkbox";
import q_searchable_static_ddl from "../../baseQuestion/searchableStaticDDL";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_checkbox,
		q_searchable_static_ddl
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		},
		show_grades_title() {
			let data = this.$store.state.q_community.answer;
			let i = this.multi_field_num - 1;
			if (!data || !data[i]) {
				return false;
			}

			return data[i].q_community_9.is_displayed;
		}
	}
};
</script>
